var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('j-abm',{attrs:{"name":"method","suppliers":_vm.suppliers,"features":{
    search: false,
    create: false,
    update: true,
    delete: false,
  }},scopedSlots:_vm._u([{key:"row",fn:function(ref){
  var item = ref.item;
return [_c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6"},[_c('h5',[_vm._v(_vm._s(item.method))]),_c('j-label',{attrs:{"icon":"number"}},[_vm._v(" "+_vm._s(item.id)+" ")])],1),_c('div',{staticClass:"col-12 col-md-6"},[_c('j-label',{attrs:{"icon":"idcard"}},[_vm._v(" "+_vm._s(item.title)+" ")])],1)])])])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }